import { gql } from '@apollo/client';

export const EXPORT_SCHOOL_SUBJECT_REPORT = gql`
  query ExportSchoolSubjectReportData($input: ExportArgs!) {
    exportSchoolSubjectReportData(input: $input) {
      id
      name
      focusSubjects {
        id
        name
      }
      grades {
        id
        name
        value
      }
      programme {
        id
        name
      }
      serviceProviders {
        id
        name
      }
      subjects {
        id
        name
        subjectGradeReference
      }
      schoolSubjectReportData {
        id
        averageMark
        class
        cluster {
          id
          name
        }
        emisNumber
        level1
        level2
        level3
        level4
        level5
        level6
        level7
        numberAbsent
        numberEnrolled
        numberWrote
        passRate
        term
        year
        promotionStatus {
          id
          name
        }
        province {
          id
          name
        }
        region {
          id
          name
        }
        subject {
          id
          name
        }
        district {
          id
          name
        }
        grade {
          id
          value
        }
        institution {
          id
          emisNumber
          name
        }
      }
    }
  }
`;
